import { GENDER_TYPE } from '@common/types';
import {
  pastDateSchema,
  optionalNullableNameSchema,
  requiredErrorMessage,
  requiredNameSchema,
  addOptionalNullableToSchema,
} from '@common/schema';
import * as yup from 'yup';
import { MAXIMUM_STRING_LENGTH } from '@common/types/constants.ts';

export const editPatientSchema = yup.object().shape({
  first_name: requiredNameSchema,
  middle_name: optionalNullableNameSchema,
  last_name: requiredNameSchema,
  preferred_name: yup.string().max(MAXIMUM_STRING_LENGTH).optional(),
  birthdate: pastDateSchema.required(requiredErrorMessage),
  gender: yup
    .string()
    .oneOf(Object.values(GENDER_TYPE))
    .required(requiredErrorMessage),
  account_status: yup
    .string()
    .oneOf(['Active', 'Inactive'])
    .required(requiredErrorMessage),
  inactivity_reason: yup
    .string()
    .when('account_status', ([account_status], schema) =>
      account_status === 'Inactive'
        ? schema
            .oneOf([
              'Deceased',
              'Transferred',
              '0 Days on Service',
              'Was GUIDE Only',
              'Not Seen in over 365 Days',
              'Declined Services',
              'No Provider Available',
            ])
            .required(requiredErrorMessage)
        : schema.optional(),
    ),
  inactivity_date: yup
    .string()
    .optional()
    .when('account_status', ([account_status], schema) =>
      account_status === 'Inactive'
        ? pastDateSchema.required(requiredErrorMessage)
        : schema.optional(),
    ),
  inactivity_date_approximate: yup
    .boolean()
    .when('account_status', ([account_status], schema) =>
      account_status === 'Inactive'
        ? schema.required(requiredErrorMessage)
        : schema.optional(),
    ),
  referral_source: yup
    .string()
    .oneOf([
      'ACC',
      'Allen Flores',
      'ARC',
      'Community marketer',
      'DTC',
      'GAIT',
      'GUIDE event',
      'Josh Allen',
      'Partner referral',
      'Premier',
      'Respite partner',
      'SNF/Rehab',
      'Stride Physical Therapy',
      'Social media',
      'Trilogy',
      'Unknown',
      'Website',
      'Wellness coordinator',
    ])
    .required(requiredErrorMessage),
  source_detail: yup
    .string()
    .oneOf([
      'Call',
      'Email',
      'Fax',
      'List - Algorithm',
      'List - Confirmed Dx',
      'List - Suspected Dx',
      'List - Unknown Dx',
      'Referral - Provider',
      'Referral - Self/Family',
      'Slack',
      'Text/SMS',
    ])
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .optional(),

  respite_eligible: yup
    .string()
    .oneOf(['Unknown', 'Eligible', 'Ineligible'])
    .required(requiredErrorMessage),

  respite_ineligibility_reason: yup
    .string()
    .oneOf(['Due to the tier', 'Due to FAST score', 'No ZBI Information'])
    .when('respite_eligible', ([respite_eligible], schema) =>
      respite_eligible === 'Ineligible'
        ? schema.required(requiredErrorMessage)
        : addOptionalNullableToSchema(schema),
    ),

  respite_partner_id: yup
    .string()
    .when('referral_source', ([referral_source], schema) =>
      referral_source === 'Respite partner'
        ? schema.required(requiredErrorMessage)
        : addOptionalNullableToSchema(schema),
    ),
});
